var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalclipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H6ZM2.063 3.041c.032-.034.062-.041.08-.041h1.143a1 1 0 1 0 0-2H2.143a2.11 2.11 0 0 0-1.536.67C.212 2.09 0 2.646 0 3.214v14.572c0 .568.212 1.124.607 1.544.396.421.947.67 1.536.67h13.714a2.11 2.11 0 0 0 1.537-.67c.394-.42.606-.976.606-1.544V3.214c0-.568-.212-1.124-.607-1.544A2.11 2.11 0 0 0 15.857 1h-1.143a1 1 0 1 0 0 2h1.143c.018 0 .048.007.08.041a.255.255 0 0 1 .063.173v14.572a.255.255 0 0 1-.063.173c-.032.034-.062.041-.08.041H2.143c-.018 0-.048-.007-.08-.041A.255.255 0 0 1 2 17.786V3.214c0-.075.029-.137.063-.173ZM8.7 6.13a1 1 0 0 1 1 1v2.745h2.8a1 1 0 1 1 0 2H9.7v2.755a1 1 0 1 1-2 0v-2.755H5a1 1 0 1 1 0-2h2.7V7.13a1 1 0 0 1 1-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalclipboard);
export default __webpack_public_path__ + "static/media/medicalclipboard.f2c0ef05945d44b22229c0f2cb309d9d.svg";
export { ForwardRef as ReactComponent };